import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import {
  EventOrderStatus,
  EventSms,
  EventSmsStatus,
} from '@/modules/eventsV2/types';

export const getSmsHistoryColumns = (): ColumnDef<EventSms>[] => [
  {
    header: 'Phone Number',
    accessorKey: 'phoneNumber',
    cell: ({ getValue }) => (getValue() ? getValue() : '–'),
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ row }) => {
      const status = row.getValue('status') as EventSmsStatus;

      const statusStyles: Record<EventSmsStatus, string> = {
        [EventSmsStatus.Sent]: 'border-green-500 text-green-500',
        [EventSmsStatus.Failed]: 'border-red-500 text-red-500',
      };

      const className = statusStyles[status] || 'border-gray-500 text-gray-500';

      return (
        <Badge variant="outline" className={className}>
          {row.getValue('status')}
        </Badge>
      );
    },
  },
  {
    size: 240,
    header: 'Date & time',
    accessorKey: 'createdAt',
    cell: ({ row }) =>
      format(new Date(row.getValue('createdAt')), 'MM/dd/yyyy · hh:mm a'),
  },
  {
    size: 400,
    header: 'Message',
    accessorKey: 'message',
    cell: ({ getValue }) => {
      const message = getValue() as string;
      return (
        <Tooltip>
          <TooltipTrigger>
            <p className="truncate max-w-[400px]">{message ? message : '–'}</p>
          </TooltipTrigger>
          <TooltipContent className="max-w-md">{message}</TooltipContent>
        </Tooltip>
      );
    },
  },
];
